






import Vue from "vue";
import NovelDetailEdit from "@/components/organisms/NovelDetailEdit.vue";

export default Vue.extend({
  props: { novelId: String },
  components: { NovelDetailEdit }
});
